export default __webpack_public_path__ + "static/media/roadmap-m-5.90b20a17.png";